import { render, staticRenderFns } from "./SpanSystemBarChart.vue?vue&type=template&id=31f51111&scoped=true&"
import script from "./SpanSystemBarChart.vue?vue&type=script&lang=ts&"
export * from "./SpanSystemBarChart.vue?vue&type=script&lang=ts&"
import style0 from "./SpanSystemBarChart.vue?vue&type=style&index=0&id=31f51111&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@6.7.3_vue-template-compiler@2.7.15_webpack@5.80.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f51111",
  null
  
)

export default component.exports